export default __webpack_public_path__ + "simplifi-logo-text-dark.svg";